import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

/** The server message to show under the name field: the `name` field error, else the global message. */
const resolveRenameErrorMessage = (extracted: ExtractedMessages | undefined): string => {
	const nameError = extracted?.fieldErrors.find((fieldError) => fieldError.field === 'name');

	return nameError?.message ?? extracted?.message ?? 'Le renommage a échoué. Réessayez.';
};

export default resolveRenameErrorMessage;
